export const MEDIA_PLAN_ACL_OBJECTS = [
    'MediaPlanList',
    'MediaPlanNew',
    'MediaPlanDetail'
];
